/* eslint-disable */

import axios from "axios";

import momentTz from "moment-timezone";

const url = require("../../client_config/config").url;

const state = {
  item: [],
  loading: false,
  dialog: false,
};

const getters = {};

const actions = {
  async getReport({ commit }, data) {
    let tz = momentTz.tz.guess();
    try {
      const response = await axios.get(
        `${url}/${data.route}/all-reports/${data.id}`,
        {
          params: { ...data.query, tz },
          responseType: "blob",
        }
      );

      return response;
    } catch (error) {
      return error;
    }
  },

  async generateReport({ commit }, data) {
    let tz = momentTz.tz.guess();
    try {
      const response = await axios.get(
        `${url}/${data.additionalQueryData.route}/generate-report/`,
        {
          params: {
            ...data,
            additionalQueryData: { ...data.additionalQueryData, tz },
          },
          responseType: "blob",
        }
      );

      return response;
    } catch (error) {
      return response.error;
    }
  },

  async generateDynamicReport({ commit }, data) {
    let tz = momentTz.tz.guess();
    try {
      const response = await axios.get(
        `${url}/${data.endpoints}`,
        {
          params: data.query,
          responseType: "blob",
        }
      );

      return response;
    } catch (error) {
      return response.error;
    }
  },

  async getAdminReports({ commit }, data) {
    try {
      const response = await axios.get(`${url}/${data.endpoint}`, {
        params: data.query,
        responseType: data.query.generateFile ? 'blob' : 'json'
      });

      if (data.query.generateFile) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `${data.query.staffName}_${data.reportType}_report.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        return response;
      }
    } catch (error) {
      console.error('Error fetching admin reports:', error);
      throw error;
    }
  },
};

const mutations = {
  SET_LOADING(state, data) {
    state.loading = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
